module.exports = __webpack_public_path__ + "img/cruises-2.b02cf0f9.png";